import axios from "axios";
import bus from "@/apis/bus";
import { getCookie, removeCookie } from "@/apis/cookie";

// 参数
const formatParams = (acParams = {}) => {
  let data;
  if (Object.prototype.toString.call(acParams) === "[object FormData]") {
    data = acParams;
  } else {
    data = { ...acParams };
  }
  return data;
};
// 请求头
const formatHeaders = (acHeaders) => {
  let headers = {};
  headers["admin-token"] = getCookie("admin-token") || '';
  headers["admin-source"] = getCookie("admin-source");
  headers["admin-language"] = getCookie("lan") || "zh_CN";
  // headers["admin-broker-id"] = getCookie("admin-broker-id") || "";
  //headers['admin-language'] = 'zh_CN';
  // headers['Content-type'] = 'application/x-www-form-urlencoded'
  // headers['exchange-time'] = formatTime(new Date().getTime())
  if (acHeaders) {
    headers = { ...headers, ...acHeaders };
  }
  return headers;
};
const http = ({
  url,
  headers,
  params,
  method,
  responseType,
  mustAll,
  apiType,
}) => {
  // let prefix = "/etf-api"
  // let prefix = "/fe-coadmin-api";
  let prefix
  if (apiType === 'fe-json-server') {
    prefix = '/fe-json-server'
  } else {
    prefix = '/fe-coagent-api'
  }
  return new Promise((resolve, reject) => {
    axios({
      url: `${prefix}/${url}`, // exchange-web-api线上  vue-api本地
      headers: formatHeaders(headers),
      data: formatParams(params),
      method: method || "post",
      responseType: responseType,
    })
      .then(function (data) {
        if (data.data.code) {
          // 100107 合约平台管理员被禁用  10002未登录
          if (data.data.code.toString() === "10002" || data.data.code.toString() === '100107') {
            // removeCookie("admin-broker-id");
            // removeCookie("admin-token");
            // removeCookie("admin-source");
            bus.$emit("outLogin");
          }
          if (data.data.code.toString() === "10006") {
            window.location.href = 'noPermissions' // 无权限
          }
          // 合约经纪人被冻结
          if (data.data.code.toString() === '220050') {
            removeCookie("admin-token");
            removeCookie("admin-source");
            bus.$emit("outLogin");
          }
          if (data.data.code.toString() === "10005") {
            removeCookie("admin-token");
            removeCookie("admin-source");
            bus.$emit("isNotUser");
          }
          // 没有权限操作
          if (data.data.code.toString() === "100068") {
            let roleType = localStorage.getItem('roleType')
            sessionStorage.removeItem("editableTabs");
            setTimeout(() => {
              if (roleType == 0 || roleType == 1) {
                window.location.href = 'agentOverview' //管理员跳转首页

              } else {
                window.location.href = 'agentBoard' //经纪人跳转首页
              }
            }, 300);

          }
        }
        if (mustAll) {
          resolve(data);
        } else {
          resolve(data.data);
        }
      })
      .catch((err) => {
        reject(err);
        throw new Error(`Error:${err}`);
      });
  });
};
export default http;
